import { jwtDecode } from 'jwt-decode';
import makeAPIRequest from 'lib/api-client';
import { useQuery } from '@tanstack/react-query';

export const metabaseLocalStorageKey = 'metabase-jwt';
const ENDPOINT = '/analytics/token';
const queryKey = 'metabase';

function getMetabaseToken(): string | null {
  return window.localStorage.getItem(metabaseLocalStorageKey);
}

function storeMetabaseToken(token: string): void {
  window.localStorage.setItem(metabaseLocalStorageKey, token);
}

const getToken = async () => {
  const token = getMetabaseToken();

  if (token) {
    const { exp } = jwtDecode(token);
    const now = Date.now() / 1000;
    if (exp && exp > now) {
      return token;
    }
  }
  const res = await makeAPIRequest(ENDPOINT, undefined, 'GET');
  if (res.status !== 200) {
    return null;
  }
  return res.body;
};

export default function useMetabaseToken() {
  return useQuery([queryKey], getToken, {
    onSuccess: data => {
      if (data) {
        storeMetabaseToken(data);
      }
    },
    initialData: getMetabaseToken(),
    refetchInterval: 3 * 60 * 60 * 1000, // 3 hours
  });
}
